var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhaseIcons02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 44,
    height: 44,
    rx: 22,
    stroke: "#CCD1E0",
    strokeWidth: 4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#001965"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9932 27.7514H17.3314C17.6852 27.7516 18.0245 27.6113 18.2748 27.3612C18.5248 27.111 18.6652 26.7716 18.6649 26.4178V21.0816C18.6652 20.7278 18.5248 20.3885 18.2748 20.1382C18.0245 19.8882 17.6852 19.7478 17.3314 19.748L14.0002 19.748",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9997 19.748L30.6695 19.748C30.3157 19.7478 29.9764 19.8882 29.7261 20.1382C29.4761 20.3885 29.3357 20.7278 29.3359 21.0816V26.4178C29.3357 26.7716 29.4761 27.111 29.7261 27.3612C29.9764 27.6113 30.3157 27.7516 30.6695 27.7514H33.9997",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3565 26.6465H28.4961C28.2099 26.6463 27.9271 26.7077 27.6668 26.8266L23.458 28.7434",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6446 20.6651C22.1385 20.3637 21.5248 20.3021 20.9689 20.497L18.668 21.3264",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.496 20.4341L26.6188 19.1676C26.0022 18.8962 25.2905 18.9533 24.7251 19.3196L22.114 21.0113C21.7216 21.2656 21.4695 21.6877 21.4317 22.1538C21.3939 22.6199 21.5746 23.0771 21.9209 23.3913V23.3913C22.3703 23.7983 23.0199 23.8965 23.5696 23.6404L25.1262 22.9141",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1263 22.9121L25.9167 23.6294C26.3339 24.0074 26.5725 24.5437 26.5741 25.1068C26.5756 25.6698 26.3398 26.2074 25.9247 26.5876L23.9068 28.4344C23.1451 29.1316 21.978 29.1346 21.2127 28.4414L19.8261 27.1839C19.4968 26.8912 19.0801 26.7153 18.6406 26.6837",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhaseIcons02);
export default __webpack_public_path__ + "static/media/Phase Icons 02.73aceff972cf07306c565164dc674de7.svg";
export { ForwardRef as ReactComponent };